import { useState, useEffect } from "react";
import { Modal, Sheet, ModalClose, Typography, Stack, FormLabel, Input, Checkbox, Button, Link, Textarea, CircularProgress } from "@mui/joy";
import { toast } from 'react-toastify';
import Tooltip from '@mui/joy/Tooltip';

import { FaCircleInfo } from "react-icons/fa6";

//Componentes
import SaldoDosItens from "../SaldoDosItens";
import UltimasCompras from "../UltimasCompras";

//Apis do RM
import { RM } from '../../services/api';
import realizaConsulta from "../../services/rm";

export default function InformacoesItem(props) {

    const novoItem = Object.keys(props.itemTemporario).length > 0;

    const [saldosDoItem, setSaldosDoItem] = useState([]);
    const [saldoTotal, setSaldoTotal] = useState(0);
    const [ultimasCompras, setUltimasCompras] = useState({});
    const [openModalInfoItem, setOpenModalInfoItem] = useState(false); //Modal de informacoes dos saldos em cada local
    const [modalUltimasCompras, setModalUltimasCompras] = useState(false);
    const [loading, setLoading] = useState(false);

    const infoNaoUsarEstoque = "O botão “Não usar estoque” deve utilizado quando se tem saldo, mas além da quantidade em estoque será necessário a aquisição de mais itens em complemento. Será necessário justificar sua escolha no campo observações.";
    const infoNaoUsarContrato = "O botão “Não usar contrato” deve ser utilizado quando as condições do contrato não atendam a demanda do solicitante, como prazo de entrega, qualidade do produto e etc. Será necessário justificar sua escolha no campo observações.";

    const [displayValue, setDisplayValue] = useState("");
    const [consumoUltimosMeses, setConsumoUltimosMeses] = useState(0);
    const [saldoOc, setSaldoOc] = useState(0);

    // Atualiza o input quando o valor do pai muda
    useEffect(() => {
        if (props.itemTemporario.precoItem != null) {
            setDisplayValue(
                Number(props.itemTemporario.precoItem).toFixed(2).replace(".", ",")
            );
        } else {
            setDisplayValue("0,00");
        }
        obterTodosSaldos(props.itemTemporario.codProduto);
        if (props.itemTemporario?.codProduto) {
            obterSaldoOC(props.itemTemporario.codProduto);
        }
    }, [props.itemTemporario?.precoItem, props.itemTemporario?.codProduto]);

    // useEffect(() => {
    // }, [])

    function handleChangePreco(e) {
        // Remove tudo que não é dígito
        const onlyDigits = e.target.value.replace(/\D/g, "");

        // Se não tiver número, considera 0
        const numericValue = onlyDigits ? parseInt(onlyDigits, 10) : 0;

        // Divide por 100 para ter centavos
        const decimalValue = numericValue / 100;

        // Atualiza o valor no props
        props.setItemTemporario({
            ...props.itemTemporario,
            precoItem: decimalValue,
        });
        // Formata para exibir no input
        setDisplayValue(decimalValue.toFixed(2).replace(".", ","));
    }


    const obterTodosSaldos = (codigoprd, open = false) => {
        setLoading(true);
        let id = null;
        if (open) {
            id = toast.loading("Buscando todos os saldos");
        }
        realizaConsulta('01.001.016', { params: { 'CODIGOPRD_S': codigoprd } })
            .then(function ({ data }) {
                let locaisComSaldo = [];
                let saldoTotal = 0;
                //Adicionando o local de estoque do pedido como um dos locais com saldo, caso haja saldo:
                // data.unshift({
                //     CODLOC: "Local do pedido",
                //     NOME: props.locaisEstoque,
                //     SALDOFISICO2: props.itemTemporario.estoque,
                //     CODIGOPRD: props.itemTemporario.codProduto,
                //     NOMEFANTASIA: props.itemTemporario.descricao,
                //     IGNORE: true //Ignorar este item na soma para não somar duas vezes
                // });

                data.forEach(saldo => {
                    if (saldo.SALDOFISICO2 > 0) {
                        // locaisComSaldo.push(saldo);
                        locaisComSaldo.push({
                            NOME: saldo.NOME,
                            SALDOFISICO2: saldo.SALDOFISICO2,
                            CODIGOPRD: saldo.CODIGOPRD,
                            NOMEFANTASIA: saldo.NOMEFANTASIA,
                            IGNORE: saldo.IGNORE || false //Indica se é o local do pedido, para não somar o saldo duas vezes
                        });
                        saldoTotal += saldo.SALDOFISICO2;
                    }
                });
                // saldoTotal = saldoTotal + props.itemTemporario.estoque;
                saldoTotal = saldoTotal;
                // if (locaisComSaldo.length > 0) {
                if (locaisComSaldo.length > 0) {
                    console.log(locaisComSaldo);
                    setSaldosDoItem(locaisComSaldo);
                    console.log(locaisComSaldo);
                    if (open) {
                        setOpenModalInfoItem(true);
                        toast.update(id, { render: "Saldos obtido com sucesso", type: "success", isLoading: false, autoClose: 1000 });
                    }
                }
                else {
                    toast.update(id, { render: "O item não possui saldos", type: "warning", isLoading: false, autoClose: 2000 });
                }
                setSaldoTotal(saldoTotal);
            }).catch(function (err) {
                toast.update(id, { render: "Erro ao obter todos os saldos", type: "error", isLoading: false, autoClose: 2000 });
                toast.error(JSON.stringify(err?.response?.data));
                console.log(err);

            }).finally(() => setLoading(false));
    }

    const obterUltimasCompras = (codigoprd) => {
        const id = toast.loading("Buscando ultimas compras");
        realizaConsulta('01.001.017', { params: { 'CODIGOPRD': codigoprd } })
            .then(function ({ data }) {
                console.log(data);
                toast.dismiss();
                setUltimasCompras(data[0]);
                setModalUltimasCompras(true);
            }).catch(function (err) {
                toast.update(id, { render: "Erro ao obter ultimas compras", type: "error", isLoading: false, autoClose: 2000 });
                toast.error(JSON.stringify(err.response.data));
            });
    }

    const obterSaldoOC = (codigoprd) => {
        const id = toast.loading("Buscando Saldo O.C do item:");
        realizaConsulta('660756', { params: { 'CODIGOPRD_S': codigoprd }, sistema: 'T', coligada: '0' })
            .then(function ({ data }) {

                const saldoValor = Array.isArray(data) && data.length > 0
                    ? data[0].QUANTIDADE
                    : data?.QUANTIDADE;

                setSaldoOc(Number(saldoValor) || 0);
                toast.dismiss();
            }).catch(function (err) {
                setSaldoOc(0);
                toast.update(id, { render: "Item Sem Saldo O.C", type: "error", isLoading: false, autoClose: 2000 });
                toast.error(JSON.stringify(err.response?.data || err.message));
            });
    }

    //Definindo se os checkbox estarão desabilitados
    const grupos = JSON.parse(localStorage.getItem('usuario')).grupo;
    //TODO: são vários grupos agora:
    // const perfil = grupos.length > 0 ? grupos[0].perfil : "";
    const perfil = grupos.length > 0 ? grupos.map(grupo => grupo.perfil) : [];
    const checkboxDesabilitado = !((
        ((props.formulario.etapaAtual == "Aprov. Técnico") && (perfil.includes(props.formulario.etapaAtual))) ||
        ((props.formulario.etapaAtual == "Solicitante"))
    ));

    const aprovacaoUrgente = props.formulario.criterio == "MP"; //aprovacao urgente quando for maquina parada

    const [precoItemTotal, setPrecoItemTotal] = useState(props.itemTemporario?.precoItemTotal || 0);

    useEffect(() => {
        if (props.itemTemporario && aprovacaoUrgente) {
            const total = Number(((props.itemTemporario.precoItem || 0) * (props.itemTemporario.quantidadeProduto || 1)).toFixed(2)).toFixed(2);
            setPrecoItemTotal(total);
        }
        obterConsumoUltimosMeses();
    }, [props.itemTemporario, aprovacaoUrgente]);

    const obterConsumoUltimosMeses = async () => {
        const result = await RM.get(`01.001.046/1/G/?parameters=CODLOC_S=${props.codLocal || "0"};CODFILIAL=${props.codFilial || "0"};IDPRD=${props.itemTemporario.idPrd || "0"};`, {
            params: {
                codProduto: props.itemTemporario.codProduto
            }
        });
        setConsumoUltimosMeses(result.data[0].CONSUMO);
    };

    return (
        <Stack>
            {Object.keys(props.itemTemporario).length > 0 ?
                <Modal
                    aria-labelledby="modal-title"
                    aria-describedby="modal-desc"
                    open={props.openModal}
                    onClose={() => props.setOpenModal(false)}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        outline: "none",
                    }}
                >
                    <Sheet
                        variant="outlined"
                        sx={{
                            width: "85%",
                            maxWidth: props.mobile ? "100%" : "1050px",
                            borderRadius: 'md',
                            p: props.mobile ? 2 : 3,
                            boxShadow: 'lg',
                            outline: "none",
                        }}
                    >
                        <ModalClose
                            variant="outlined"
                            sx={{
                                top: "calc(-1/4 * var(--IconButton-size))",
                                right: "calc(-1/4 * var(--IconButton-size))",
                                boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                                borderRadius: "50%",
                                bgcolor: "background.surface",
                            }}
                        />
                        <Typography
                            component="h2"
                            id="modal-title"
                            level="h4"
                            textColor="inherit"
                            fontWeight="lg"
                            mb={1}
                        >
                            Informações do Item
                        </Typography>

                        <Stack display={"flex"} sx={props.mobile ? { overflow: "auto", height: "70vh" } : {}}>
                            <Stack flexDirection={props.mobile ? "column" : "row"} mt="20px">
                                <Stack width="100px" flexDirection={"column"} mr="20px">
                                    <FormLabel>Código</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.codProduto} />
                                </Stack>
                                <Stack width={props.mobile ? "100%" : "60%"} flexDirection={"column"} mr="20px">
                                    <FormLabel>Descrição</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.descricao} />
                                </Stack>
                            </Stack>

                            <Stack flexDirection={"row"} mt="20px">
                                <Stack flexDirection={"column"} mr="20px" sx={props.mobile ? { width: "70px" } : { width: "220px" }}>
                                    <FormLabel>Saldo estoque na data do pedido</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.estoque} />
                                </Stack>
                                <Stack flexDirection={"column"} mr="10px" sx={props.mobile ? { width: "50px" } : { width: "70px" }}>
                                    <FormLabel>Min.</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.saldoMin} />
                                </Stack>
                                <Stack flexDirection={"column"} mr="10px" sx={props.mobile ? { width: "50px" } : { width: "70px" }}>
                                    <FormLabel>Max.</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.saldoMax} />
                                </Stack>
                                <Stack flexDirection={"column"} mr="10px" sx={props.mobile ? { width: "50px" } : { width: "70px" }}>
                                    <FormLabel>Unidade</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.CODUND || props.itemTemporario.unidade} />
                                </Stack>
                                <Stack flexDirection={"column"} mr="10px" sx={props.mobile ? { width: "50px" } : { width: "auto" }}>
                                    <FormLabel>Marca</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.MARCA || props.itemTemporario.marca} />
                                </Stack>
                                {/* <Stack flexDirection={"column"} mr="10px" sx={props.mobile ? { width: "50px" } : { width: "160px" }}>
                                    <FormLabel>Saldo de estoque total</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={saldoTotal || ""} />
                                </Stack> */}
                                {/* <Stack>
                                    <Link>Ver Ultimas Compras</Link>
                                </Stack> */}
                            </Stack>

                            <Stack flexDirection={props.mobile ? "column" : "row"} mt="20px">
                                <Stack flexDirection={"column"} mr="0px" mb={props.mobile ? "20px" : "0"}>
                                    <Link onClick={() => { obterTodosSaldos(props.itemTemporario.codProduto, true) }} mr="20px">
                                        Ver todos os locais de estoque
                                    </Link>
                                    {loading ? (
                                        <Stack display={'flex'} justifyContent={'center'} width="240px">
                                            <CircularProgress size="sm" sx={{ marginTop: "5px", alignSelf: "center" }} />
                                        </Stack>
                                        // <Input sx={{ backgroundColor: "#fff8e1", margin: 0, width: "fit-content", padding: '4px 10px' }} disabled variant="plain" value="Carregando..." />
                                    ) : (
                                        <Input sx={{ backgroundColor: "#fff8e1", margin: 0, width: "fit-content", padding: '4px 10px' }} disabled variant="plain" value={"Saldo de estoque total: " + (saldoTotal || "0")} placeholder="Quantidade de locais com saldo" />
                                    )}
                                </Stack>
                                <Stack mr="20px">
                                    <Link onClick={() => obterUltimasCompras(props.itemTemporario.codProduto)}>Ver ultimas compras</Link>
                                </Stack>
                                <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                    <FormLabel>Total de consumo ultimos 3 meses</FormLabel>
                                    <Input sx={{ width: "fit-content", padding: '4px 10px', border: 0 }} disabled value={consumoUltimosMeses || "0"} />
                                </Stack>
                                <Stack width="150px" flexDirection={"column"} mr="10px" mt={props.mobile ? "20px" : "0px"}>
                                    <FormLabel>Saldo de Contrato</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.saldoContrato} />
                                </Stack>
                                <Stack width="150px" flexDirection={"column"} mr="10px">
                                    <FormLabel>Saldo de O.C</FormLabel>
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={saldoOc} />
                                </Stack>
                                {/* Sla de contrato aparece para o solicitante apenas: */}
                                {
                                    // props.formulario.etapaAtual == "Solicitante" ? 
                                    // <Stack width="170px" flexDirection={"column"} mr="10px">
                                    //     <FormLabel>SLA Item Contrato (dias)</FormLabel>
                                    //     {/* {console.log(props.itemTemporario)} */}
                                    //     <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.slaContrato || props.itemTemporario.SLACONTRATO} />
                                    // </Stack>
                                    //  :
                                    //  null
                                }

                            </Stack>

                            <Stack flexDirection={props.mobile ? "column" : "row"} mt="20px">
                                <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                    <FormLabel>Quantidade</FormLabel>
                                    <Input type="number" placeholder="Quantidade"
                                        value={props.itemTemporario.quantidadeProduto}
                                        sx={{ width: "150px" }}
                                        onChange={(event) => props.setItemTemporario({ ...props.itemTemporario, quantidadeProduto: event.target.value })} disabled={(props.etapaAtual != "Solicitante") || (props.osVinculada) || (props.formulario.usuario_id ? props.usuarioLogado != props.formulario.usuario_id : false)}
                                        // onKeyUp={(event) => novoItem ? props.setItemTemporario({ ...props.itemTemporario, QUANTIDADEARECEBER: event.target.value.match(/^-/, '') }) : props.atualizarFormulario("QUANTIDADEARECEBER", event.target.value.match(/^-/, ''), true)}
                                        onKeyUp={(event) => props.setItemTemporario({ ...props.itemTemporario, quantidadeProduto: event.target.value.replace("-", "") })}
                                    />
                                </Stack>

                                {aprovacaoUrgente ?
                                    <>
                                        <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                            <FormLabel>Preço Item</FormLabel>
                                            <Input type="text" placeholder="Preço Item"
                                                value={displayValue}
                                                sx={{ width: "150px" }}
                                                onChange={handleChangePreco}
                                                disabled={(props.etapaAtual != "Solicitante") || (props.formulario.usuario_id ? props.usuarioLogado != props.formulario.usuario_id : false)}
                                            />
                                        </Stack>

                                        <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                            <FormLabel>Total Preço Item</FormLabel>
                                            <Input
                                                type="number"
                                                sx={{ width: "150px" }}
                                                placeholder="Preço Item"
                                                value={precoItemTotal}
                                                disabled={true}
                                            />
                                        </Stack>
                                    </>
                                    :
                                    null
                                }

                                <Stack flexDirection={"column"} mr="30px" mb={props.mobile ? "10px" : "0"}>
                                    <Stack flexDirection={"row"} alignItems="center">
                                        <FormLabel sx={{ marginRight: '5px' }}>Não usar estoque</FormLabel>
                                        <Tooltip arrow title={infoNaoUsarEstoque} color="primary" placement="top" variant={"solid"}>
                                            {/* <Button variant="" color="primary"><FaCircleInfo></FaCircleInfo></Button> */}
                                            <FaCircleInfo></FaCircleInfo>
                                        </Tooltip>
                                    </Stack>

                                    <Checkbox disabled={checkboxDesabilitado || !props.itemTemporario.estoque || props.transferencia} checked={props.itemTemporario.naoUsarEstoque || !props.itemTemporario.estoque}
                                        sx={{ marginTop: '8px' }}
                                        onChange={(event) => props.setItemTemporario({ ...props.itemTemporario, naoUsarEstoque: event.target.checked })}
                                    />
                                </Stack>

                                <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                    <Stack flexDirection={"row"} alignItems="center">
                                        <FormLabel sx={{ marginRight: '5px' }}>Não usar contrato</FormLabel>
                                        <Tooltip arrow title={infoNaoUsarContrato} color="primary" placement="top" variant={"solid"}>
                                            <FaCircleInfo></FaCircleInfo>
                                        </Tooltip>

                                    </Stack>
                                    <Checkbox
                                        sx={{ marginTop: '8px' }}
                                        disabled={checkboxDesabilitado || props.transferencia} checked={novoItem ? props.itemTemporario.naoUsarContrato : props.itemTemporario.itens[props.indiceItemConsultado].naoUsarContrato}
                                        onChange={(event) => props.setItemTemporario({ ...props.itemTemporario, naoUsarContrato: event.target.checked })}
                                    />
                                </Stack>
                                {/* <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                    <FormLabel>Total de consumo ultimos 3 meses</FormLabel>
                                    <Input sx={{ margin: 0, width: "fit-content", padding: '4px 10px' }} disabled variant="plain" value={consumoUltimosMeses || "0"} />
                                </Stack> */}
                                <Stack width="170px" flexDirection={"column"} mr="10px">
                                    <FormLabel>SLA Item Contrato (dias)</FormLabel>
                                    {/* {console.log(props.itemTemporario)} */}
                                    <Input disabled variant="plain" sx={{ margin: 0, padding: 0 }} value={props.itemTemporario.slaContrato || props.itemTemporario.SLACONTRATO} />
                                </Stack>
                            </Stack>

                            <Stack flexDirection={props.mobile ? "column" : "row"} mt="20px">
                                <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "20px" : "0"}>
                                    <FormLabel>Preço Unt. Alvo</FormLabel>
                                    <Input type="text" disabled={true} placeholder="Preço Unt. Alvo" value={props.itemTemporario.precoUntAlvo} />
                                </Stack>
                                <Stack flexDirection={"column"} mr="20px">
                                    <FormLabel>Id. Objeto Oficina</FormLabel>
                                    <Input type="text" disabled={true} placeholder="Id. Objeto Oficina" value={props.itemTemporario.idObjetoOficina} />
                                </Stack>
                                {/* <Stack flexDirection={"column"} mr="20px" mb={props.mobile ? "10px" : "0"}>
                                    <FormLabel>Total de consumo ultimos 3 meses</FormLabel>
                                    <Input sx={{ width: "fit-content", padding: '4px 10px' }} disabled value={consumoUltimosMeses || "0"} />
                                </Stack> */}
                            </Stack>

                            <Stack flexDirection={"row"} mt="20px" mb="20px">
                                <Stack flexDirection={"column"} mr="20px" width="100%">
                                    <FormLabel>Observacoes</FormLabel>
                                    {/* <Textarea minRows={4} placeholder="Observações" disabled={(props.etapaAtual != "Solicitante" || props.osVinculada)} */}
                                    <Textarea minRows={4} placeholder="Observações" disabled={(props.etapaAtual != "Solicitante")}
                                        value={props.itemTemporario.observacoesItem}
                                        onChange={(event) => props.setItemTemporario({ ...props.itemTemporario, observacoesItem: event.target.value })}
                                    />
                                </Stack>
                            </Stack>
                        </Stack>

                        {/* {((props.etapaAtual == "Solicitante" && !props.osVinculada) || (props.etapaAtual == "Aprov. Técnico")) ? */}
                        {((props.etapaAtual == "Solicitante") || (props.etapaAtual == "Aprov. Técnico")) ?
                            <Button
                                variant="solid"
                                size="md"
                                color="primary"
                                aria-label="Adicionar"
                                sx={{
                                    m: "auto",
                                    mb: "20px",
                                    alignSelf: "center",
                                    fontWeight: 600,
                                }}
                                style={props.mobile ? { marginTop: "15px" } : {}}
                                disabled={!(props.itemTemporario.quantidadeProduto && parseInt(props.itemTemporario.quantidadeProduto, 10) >= 0)}
                                // disabled={((props.itemTemporario != {} && props.itemTemporario.quantidadeProduto == "" || props.itemTemporario.quantidadeProduto == "-"))}
                                // onClick={() => props.acrescentarItem()}
                                onClick={() => {
                                    if (props.formulario.criterio == "MP" && props.itemTemporario?.observacoesItem?.trim() == "") {
                                        alert("Preencha o campo 'Observações' do item.");
                                        return;
                                    }
                                    if (props.formulario.criterio == "MP" && (!props.itemTemporario?.precoItem || props.itemTemporario.precoItem <= 0)) {
                                        alert("Informe o preço do item.");
                                        return;
                                    }
                                    props.acrescentarItem();
                                }}
                            >
                                Confirmar
                            </Button>
                            : null}
                    </Sheet>
                </Modal>
                : null
            }

            {/* Modal saldo dos itens */}
            <SaldoDosItens
                openModalInfoItem={openModalInfoItem}
                setOpenModalInfoItem={setOpenModalInfoItem}
                saldosDoItem={saldosDoItem}
            />

            <UltimasCompras
                open={modalUltimasCompras}
                setOpen={setModalUltimasCompras}
                data={ultimasCompras}
            />
        </Stack>
    );
}